export default {   
    /*Ruta para acceder al module  */
    SIAHE_AUTH: 'core/auth/',
    SIAHE_CATALOGO: 'core/catalogo/',
    SIAHE_ACTIVACION: 'core/activacion/',
    SIAHE_PASSWORD: 'core/changePassword/',
}